// @Vendors
import React , { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-final-form';
import Button from '@material-ui/core/Button';
import { Redirect } from 'react-router-dom';

// @State
import {
  selectAuthenticatedError,
  selectAuthenticatedErrorMessage,
  selectIsAuthenticated,
  selectIsLoading, selectIsWaiting,
  selectLogin,
    selectWebToken,
    selectUserLogged
} from '../../state/auth/auth.selectors';
import {doLogin, checkLogin, cancelCheckLogin} from '../../state/auth/auth.actions';

// @Components
import HooliLogo from '../../components/HooliLogo';
import InputGrp from '../../components/form/InputGrp';
import Loading from '../../components/Loading';

// @Utils
import { getCookie } from '../../utils/session';
import { getSessionId, getAuthorizationToken } from '../../utils/auth';

class Login extends Component {
  constructor() {
    super();
    this.state = {
      locationObtained: false,
      lat: '',
      lng: '',
      attempts: 0,
      doc: ''
    }
  }

  componentDidMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos => {
        this.setState({locationObtained: true, lat: pos.coords.latitude.toFixed(6), lng: pos.coords.longitude.toFixed(6)})
      }, console.error);
    }
  }

  cancelLogin() {
    const {cancelCheckLogin} = this.props;
    this.setState({attempts: 0});
    cancelCheckLogin()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {isWaiting, checkLogin, cancelCheckLogin, webToken} = this.props;
    if (prevProps.isWaiting !== isWaiting && isWaiting) {
      this.interval = setInterval(() => {
        this.setState(state => ({attempts: state.attempts + 1}));
        checkLogin({usuarioNroDeDocumento: this.state.doc, usuarioLogInWebToken: webToken, sesionLatitud: this.state.lat, sesionLongitud: this.state.lng})
        if (this.state.attempts >= 60) {
          this.cancelLogin()
        }
      }, 3000)
    }
    else if (!isWaiting && this.interval) clearInterval(this.interval);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleSubmitForm = values => {
    const { doLogin } = this.props;
    this.setState({doc: values.usuarioNroDeDocumento})
    doLogin({...values, sesionLatitud: this.state.lat, sesionLongitud: this.state.lng});
  }

  handleValidate = values => {
    const errors = {};
    if (!values.usuarioNroDeDocumento) errors.usuarioNroDeDocumento = "Requerido";
    return errors;
  }

  buildError = () => {
    const { authenticatedError, authenticatedErrorMessage, } = this.props;

    return authenticatedError
      ? <div className="message-error">{authenticatedErrorMessage}</div>
      : null
  }

  render () {
    const { login, isAuthenticated, isLoading, isWaiting, userLogged } = this.props;
    const path = getCookie('redirect') || '';

    return !isAuthenticated ? (
      <Fragment>
        <Form
          onSubmit={this.handleSubmitForm}
          initialValues={login}
          validate={this.handleValidate}
          render={({ handleSubmit }) => (
            <form autoComplete="off" onSubmit={handleSubmit}>
              <HooliLogo />
              {this.buildError()}
              <InputGrp id="standard-name" name="usuarioNroDeDocumento" label="DNI" type="password" autoComplete="current-password" />
              {!this.state.locationObtained && <p>Debemos conocer tu ubicación actual para el login</p>}
              {isWaiting && <p>Accede a la app y verifica tu identidad</p>}
              <Button type="submit" variant="contained" color="primary" className='btn_medium' disabled={!this.state.locationObtained}>
                {
                  !isLoading
                    ? 'Ingresar'
                    : <Loading show />
                }
              </Button>
            </form>
          )}
        />
      </Fragment>
    )
    : <Redirect to={path} />;
  }
};

const mapStateToProps = state => ({
  authenticatedError: selectAuthenticatedError(state),
  authenticatedErrorMessage: selectAuthenticatedErrorMessage(state),
  isAuthenticated: selectIsAuthenticated(state),
  isLoading: selectIsLoading(state),
  login: selectLogin(state),
  isWaiting: selectIsWaiting(state),
  webToken: selectWebToken(state),
  userLogged: selectUserLogged(state),
});

const actions = {
  doLogin,
  checkLogin,
  cancelCheckLogin
};

export default connect(
  mapStateToProps,
  actions
)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/index.js